import { canPaginate } from '../../mixins/can_paginate';
import '../broadcast/tickets_refund_form_controller';
import { NEW_ADMIN_URL } from 'environment';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/accounts/:account_id/channels/:id', {
        template: require('./channel.html'),
        controller: 'ChannelController'
    });
})
.controller('ChannelController', function($scope, $location, $route, $routeParams, $modal, Account, AccountChannel, ChannelTicket){
  canPaginate($scope, $location)
  $scope.account = Account.get({id: $routeParams.account_id});
  $scope.newAdminURL = NEW_ADMIN_URL;
  $scope.defaultPageLength = 50;
  $scope.channel = AccountChannel.get({account_id: $routeParams.account_id, id: $routeParams.id}, function(data){
    if (data.is_ticketed) {
      $scope.soldTicketCount = $scope.channel.sold_ticket_count;
      $scope.selectedTickets = [];
      $scope.selectAll = false;
      $scope.validTicketCount = 0;
      $scope.selectedTicketTotal = 0;
      $scope.queryHasRun = false;
      $scope.queryRunning = false;
      let params = _.pick($scope, 'q', 's', 'p');
      params.channel_id = $routeParams.id;
      params.l = $scope.defaultPageLength;
      ChannelTicket.query(params, function(data, getResponseHeader){
        $scope.tickets = data;
        $scope.unrefunded = _.where($scope.tickets, {is_refunded: false})
        $scope.totalTicketRevenue = _.reduce($scope.tickets,  ((m, t) => (m + t.price)), 0.0);
        $scope.netTicketRevenue = _.reduce($scope.unrefunded,  ((m, t) => (m + t.price)), 0.0);
        $scope.refundedTotal = $scope.tickets.length - $scope.unrefunded.length;
        $scope.validTicketCount = $scope.soldTicketCount - $scope.refundedTotal;
        const pagination = getResponseHeader('X-Pagination');
        $scope.pagination = (pagination ? JSON.parse(pagination) : {});
      });
      $scope.selectSingleTicket = function(ticket) {
        if(!$scope.selectedTickets.includes(ticket)){
          $scope.selectedTickets.push(ticket);
        } else {
          $scope.selectedTickets = $scope.selectedTickets.filter(function(value,index, arr) {
            return value != ticket
          })
        }
        $scope.selectedTicketTotal = $scope.selectedTickets.length;
      };

      $scope.selectAllPageTickets = () => {
        if(!$scope.selectAll) {
          $scope.deselectAllTickets();
        } else {
          $scope.selectedTickets = $scope.unrefunded;
        }
        $scope.selectedTicketTotal = $scope.selectedTickets.length;
      };

      $scope.selectAllTickets = () => {
        $scope.selectAll = true
        if(!$scope.queryHasRun) {
          $scope.queryRunning = true;
          $scope.l = $scope.soldTicketCount;
          ChannelTicket.query({channel_id: $routeParams.id, l: $scope.l}, function(data) {
            $scope.totalTickets = data;
            $scope.unrefundedAllTickets = _.where($scope.totalTickets, {is_refunded: false})
            $scope.queryHasRun = true;
            $scope.queryRunning = false;
            $scope.selectedTickets = $scope.unrefundedAllTickets;
            $scope.selectedTicketTotal = $scope.validTicketCount;
            $scope.allTicketsSelected = true;
          });
        } else {
          $scope.selectedTickets = $scope.unrefundedAllTickets;
          $scope.selectedTicketTotal = $scope.validTicketCount;
          $scope.allTicketsSelected = true;
        }
      };

      $scope.deselectAllTickets = () => {
        $scope.selectAll = false;
        $scope.selectedTickets = [];
        $scope.allTicketsSelected = false;
        $scope.selectAll = false;
      };

      $scope.refundTickets = () =>
        $modal.open({
          template: require('../broadcast/tickets_refund_form.html'),
          controller: 'TicketsRefundFormController',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            tickets: () => $scope.selectedTickets,
            channel: () => $scope.channel,
            account: () => $scope.account,
            broadcast: () => {},
          },
        }).result.then(() => {
          $route.reload();
        });
    }
  });

  return $scope.showTicket = e=> $location.path(`/accounts/${$routeParams.account_id}/channels/${$routeParams.id}/tickets/${e.id}`);
});



// WEBPACK FOOTER //
// ./views/channel/channel_controller.js